// src/utils/metaPixel.js
// Envoie un évènement standard au Pixel Meta (fbq), si celui-ci est chargé.
// Le script de base du pixel doit être présent dans public/index.html
// (voir instructions fournies) pour que window.fbq existe.

/**
 * Déclenche un évènement standard Meta Pixel.
 * @param {string} eventName - ex: 'CompleteRegistration', 'Lead', 'ViewContent', 'InitiateCheckout'
 * @param {object} params - ex: { value: 10, currency: 'EUR', content_name: 'essai' }
 */
export const trackMetaPixelEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') {
    // Pixel pas encore chargé (ex: adblock, ou script pas encore installé) — on ne bloque pas l'app.
    console.warn(`[MetaPixel] fbq indisponible, évènement "${eventName}" non envoyé`);
    return;
  }
  window.fbq('track', eventName, params);
};

// Raccourci pour la conversion principale : inscription confirmée à un cours.
export const trackMetaRegistrationConversion = ({ value, currency = 'EUR', planId, courseIds } = {}) => {
  trackMetaPixelEvent('CompleteRegistration', {
    value,
    currency,
    content_name: planId,
    content_ids: courseIds,
    content_type: 'product',
    status: true
  });
};
